import { createRouter, createWebHistory } from "vue-router";
import { trackPage } from "../composables/useAnalytics";

const routes = [
  {
    path: "/",
    name: "portfolio",
    component: () => import("../views/PortfolioView.vue"),
    meta: {
      title:
        "Jeff Adler — Director of Engineering at Dropbox | AI & Agentic Engineering Leader, Denver CO",
      description:
        "Jeff Adler (jadler/jads) is a Director of Engineering at Dropbox building AI products with LLMs, Claude, and agentic orchestration. Previously Staff iOS Engineer at Reddit, Senior Engineer at Google. Engineering leader specializing in AI, ML, agents, and agentic engineering. Based in Denver, CO.",
    },
  },
  {
    path: "/blog",
    name: "blog",
    component: () => import("../views/BlogIndex.vue"),
    meta: {
      title:
        "Jads Blog - Jeff Adler | Engineering Leadership, AI, Agentic Development",
      description:
        "Jeff Adler's engineering blog. AI, agentic engineering, leadership, iOS architecture, and technical deep dives from Google, Dropbox, and Reddit.",
    },
  },
  {
    path: "/blog/from-tech-lead-to-director",
    redirect: "/blog/staff-to-senior-manager-90-percent-same-job",
  },
  {
    path: "/blog/:slug",
    name: "blog-post",
    component: () => import("../views/BlogPost.vue"),
    meta: {
      title: "Jads Blog — Jeff Adler",
      description:
        "Blog post by Jeff Adler, Director of Engineering at Dropbox.",
    },
  },
  {
    path: "/terminal",
    name: "terminal",
    component: () => import("../views/TerminalChat.vue"),
    meta: {
      title: "Jadbot Terminal — Jeff Adler",
      description:
        "Chat with Jadbot, an AI assistant that knows everything about Jeff Adler.",
    },
  },
  {
    path: "/now",
    name: "now",
    component: () => import("../views/NowView.vue"),
    meta: {
      title: "Now — Jeff Adler",
      description:
        "What Jeff is focused on right now: current work, writing, reading, and side projects.",
    },
  },
  {
    path: "/about",
    name: "about",
    component: () => import("../views/AboutView.vue"),
    meta: {
      title: "About Jeff Adler - Director of Engineering at Dropbox",
      description:
        "Jeff Adler is Director of Engineering at Dropbox (Dash) in Denver, Colorado. Bio, career, and FAQ. Formerly Reddit and Google.",
    },
  },
  {
    path: "/writing/:topic",
    name: "hub",
    component: () => import("../views/HubView.vue"),
    meta: {
      title: "Writing — Jeff Adler",
      description:
        "Topic hubs by Jeff Adler: agentic engineering, engineering leadership, and iOS architecture.",
    },
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

router.beforeEach((to, from, next) => {
  document.title =
    to.meta.title ||
    "Jeff Adler — Director of Engineering at Dropbox | jads.app";
  const desc = document.querySelector('meta[name="description"]');
  if (desc && to.meta.description) {
    desc.setAttribute("content", to.meta.description);
  }
  const canonical = document.querySelector('link[rel="canonical"]');
  if (canonical) {
    canonical.setAttribute("href", `https://jads.app${to.path}`);
  }
  const ogUrl = document.querySelector('meta[property="og:url"]');
  if (ogUrl) {
    ogUrl.setAttribute("content", `https://jads.app${to.path}`);
  }
  const blogLd = document.querySelector("script[data-blog-ld]");
  if (blogLd && to.name !== "blog-post") {
    blogLd.remove();
  }
  const blogIndexLd = document.querySelector("script[data-blog-index-ld]");
  if (blogIndexLd && to.name !== "blog") {
    blogIndexLd.remove();
  }
  const aboutLd = document.querySelector("script[data-about-ld]");
  if (aboutLd && to.name !== "about") {
    aboutLd.remove();
  }
  const hubLd = document.querySelector("script[data-hub-ld]");
  if (hubLd && to.name !== "hub") {
    hubLd.remove();
  }
  document
    .querySelectorAll('meta[property="article:tag"]')
    .forEach((el) => el.remove());
  next();
  trackPage();
});

export default router;
